import React from 'react';
import { Controller, useForm } from "react-hook-form";
import "../i18n";
import { useTranslation } from "react-i18next";
import FormControl from '@mui/material/FormControl';

export default function OtpForm(props) {
    const { t, i18n } = useTranslation();
    const public_URL = process.env.PUBLIC_URL;
    const { handleSubmit, control, formState: { errors } } = useForm();
    const [buttonClicked, setButtonClicked] = React.useState(false);
    const [mediumFont, setMediumFont] = React.useState("MontserratMedium");
    const [boldFont, setBoldFont] = React.useState("MontserratBold");

    React.useEffect(() => {
        console.log("OtpForm language:" + props.language);
        i18n.changeLanguage(props.language);
        changeFontbyLanguage(props.language);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    function changeFontbyLanguage(lan) {
        if (lan === "zh") {
            setMediumFont('NotoSansSCMedium');
            setBoldFont('NotoSansSCBold');
        }
        else if (lan === "kr") {
            setMediumFont('NotoSansKRMedium');
            setBoldFont('NotoSansKRBold');
        }
        else if (lan === "en" || lan === "vn") {
            setMediumFont('MontserratMedium');
            setBoldFont('MontserratBold');
        }
    }

    const handleOnSubmit = (data) => {
        console.log(data);
        setButtonClicked(true);
        if (props.onSubmit) {
            props.onSubmit(data, props.enrollmentId);
        }
    }

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#f0f0f0',
            margin: '0',
            padding: '0'
        }}>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                <div class="div">
                    {/* Keep exact same header as enrollment form */}
                    <div class="div-img-small">
                        {/* Logo - minimal spacing */}
                        <div class="logo-container">
                            <img
                                src={public_URL + "/images/HOIANAREWARDSLOGO.svg"}
                                class="img"
                                alt=""
                                loading="lazy"
                            />
                        </div>

                        {/* Welcome text - compact */}
                        <div class="header-welcome-section">
                            <div class={"header-welcome-text " + boldFont}>{t("Welcome1")}</div>
                            <div class={"header-welcome-text " + boldFont}>{t("Welcome2")}</div>
                        </div>
                    </div>

                    {/* Form section styled to match the image */}
                    <div style={{
                        padding: '60px 40px',
                        backgroundColor: '#f0f0f0',
                        textAlign: 'center',
                        minHeight: 'calc(100vh - 200px)'
                    }}>
                        <Controller
                            control={control}
                            name="otp"
                            rules={{ required: t('OtpRequired') }}
                            render={({ field }) => (
                                <div>
                                    {/* Label */}
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '30px',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#2e7d79',
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        lineHeight: '1.3'
                                    }} className={boldFont}>
                                        {t("EnterOPT")}
                                    </label>

                                    {/* Input Field */}
                                    <div style={{ marginBottom: '40px' }}>
                                        <input
                                            {...field}
                                            style={{
                                                width: '300px',
                                                padding: '15px 20px',
                                                border: '2px solid #a0a0a0',
                                                borderRadius: '8px',
                                                fontSize: '16px',
                                                textAlign: 'center',
                                                backgroundColor: '#f8f9fa',
                                                outline: 'none',
                                                transition: 'border-color 0.2s ease',
                                                boxSizing: 'border-box',
                                                letterSpacing: '2px',
                                                fontFamily: 'inherit'
                                            }}
                                            className={mediumFont}
                                            placeholder=""
                                            onFocus={(e) => {
                                                e.target.style.borderColor = '#2e7d79';
                                                e.target.style.backgroundColor = 'white';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = errors.otp ? '#ef4444' : '#a0a0a0';
                                                e.target.style.backgroundColor = '#f8f9fa';
                                            }}
                                        />
                                    </div>

                                    {/* Error Message */}
                                    {errors.otp && (
                                        <div style={{
                                            color: '#ef4444',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            marginBottom: '20px'
                                        }} className={mediumFont}>
                                            {errors.otp.message}
                                        </div>
                                    )}
                                </div>
                            )}
                        />

                        {/* Next Button */}
                        <div>
                            <button
                                type="submit"
                                disabled={buttonClicked}
                                style={{
                                    width: '300px',
                                    background: buttonClicked
                                        ? '#9ca3af'
                                        : '#d4a574',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '25px',
                                    padding: '15px 32px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '2px',
                                    cursor: buttonClicked ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    boxShadow: buttonClicked
                                        ? 'none'
                                        : '0 2px 8px rgba(212, 165, 116, 0.3)'
                                }}
                                className={mediumFont}
                                onMouseEnter={(e) => {
                                    if (!buttonClicked) {
                                        e.target.style.background = '#c69660';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!buttonClicked) {
                                        e.target.style.background = '#d4a574';
                                    }
                                }}
                            >
                                {t("Next")}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}